<ng-container [formGroup]="locationForm">
	<p class="warning">{{ "address.incomplete" | translate }}</p>
	<div class="double-input">
		<pv-input
			#streetError="icNgxErrors"
			formControlName="street"
			icNgxErrors
			icon="fa fa-road"
			label="{{ 'address.street' | translate }}"
			ngxErrors="street"
			placeholder="{{ 'address.street' | translate }}"
			type="text"
			[class.error]="streetError.hasError('*', 'touched')"
		>
			<p *ngxError="'required'; showWhen: 'touched'" class="errors">{{ "error.required" | translate }}</p>
		</pv-input>
		<pv-input
			#numberError="icNgxErrors"
			formControlName="number"
			icNgxErrors
			icon="fa fa-home"
			label="{{ 'address.number' | translate }}"
			ngxErrors="number"
			placeholder="{{ 'address.number' | translate }}"
			type="text"
			[class.error]="numberError.hasError('*', 'touched')"
			>>
			<p *ngxError="'required'; showWhen: 'touched'" class="errors">{{ "error.required" | translate }}</p>
		</pv-input>
	</div>
	<div class="double-input">
		<pv-input
			formControlName="box"
			icon="fa fa-inbox"
			label="{{ 'address.box' | translate }}"
			placeholder="{{ 'address.box' | translate }}"
			type="text"
			[required]="false"
		/>
		<pv-input
			#zipError="icNgxErrors"
			formControlName="zip"
			icNgxErrors
			icon="fa fa-hdd-o"
			label="{{ 'address.zip' | translate }}"
			ngxErrors="zip"
			placeholder="{{ 'address.zip' | translate }}"
			type="text"
			[class.error]="zipError.hasError('*', 'touched')"
			>>
			<p *ngxError="'required'; showWhen: 'touched'" class="errors">{{ "error.required" | translate }}</p>
		</pv-input>
	</div>
	<div class="double-input">
		<pv-input
			#cityError="icNgxErrors"
			formControlName="city"
			icNgxErrors
			icon="fa fa-building"
			label="{{ 'address.city' | translate }}"
			ngxErrors="city"
			placeholder="{{ 'address.city' | translate }}"
			type="text"
			[class.error]="cityError.hasError('*', 'touched')"
			>>
			<p *ngxError="'required'; showWhen: 'touched'" class="errors">{{ "error.required" | translate }}</p>
		</pv-input>
		<pv-input
			formControlName="state"
			icon="fa fa-map"
			label="{{ 'address.state' | translate }}"
			placeholder="{{ 'address.state' | translate }}"
			type="text"
			[required]="false"
		/>
	</div>
	<pv-input
		#countryError="icNgxErrors"
		formControlName="country"
		icNgxErrors
		icon="fa fa-flag"
		label="{{ 'address.country' | translate }}"
		ngxErrors="country"
		placeholder="{{ 'address.country' | translate }}"
		type="text"
		[class.error]="countryError.hasError('*', 'touched')"
	>
		<p *ngxError="'required'; showWhen: 'touched'" class="errors">{{ "error.required" | translate }}</p>
	</pv-input>
	<div class="ic-button-container">
		<ui-double-button
			icon="fa fa-save"
			type="primary"
			[icValidateForms]="[locationForm]"
			(confirm)="save()"
			(invalidEvent)="invalid()"
		>
			{{ "actions.save" | translate }}
		</ui-double-button>

		<ui-double-button icon="fa fa-times" type="secondary" (action)="cancel()">
			{{ "actions.cancel" | translate }}
		</ui-double-button>
	</div>
</ng-container>
